import { z } from 'zod'

/**
 * Normalizes comment text before enforcing its intrinsic 4,000-character
 * limit.
 */
export const CommentTextSchema = z
  .string()
  .trim()
  .min(1, 'Comments cannot contain only whitespace')
  .max(4000)

/** Comment text after shared normalization and validation. */
export type CommentText = z.infer<typeof CommentTextSchema>
